module.exports = __webpack_public_path__ + "img/oxbr.8d9c83af.png";